"use client";

import { breakpointDesktop, IconButton } from "@gnist/design-system";
import NextLink from "@/components/nextLink";
import { styled } from "styled-components";
import { tokens } from "@gnist/themes/tokens.css.js";

const ButtonWrapper = styled.div`
  margin-bottom: ${tokens.spacing.xs};

  @media screen and (min-width: ${breakpointDesktop}) {
    margin-bottom: ${tokens.spacing.l};
  }
`;

export const BackButton = ({ departmentSlug }: { departmentSlug?: string }) => {
  return (
    <ButtonWrapper>
      <IconButton
        icon="arrow_backward"
        label="Til forsiden"
        showLabel="right"
        $as={NextLink}
        href={departmentSlug ? `/forhandler/${departmentSlug}` : "/"}
      />
    </ButtonWrapper>
  );
};
